import React from "react"
import CreateUserCard from "./UserCard";

export function RegistrationPage() {

    return (
        <div className="hold-transition login-page">
            <div className="login-box">
                <div className="mt-5">
                    <CreateUserCard />
                </div>
            </div>

        </div>
    )
}

export default RegistrationPage;